import { create } from 'zustand';

interface Store {
  opened: boolean;
  showCloseButton: boolean;
  setOpened: (flag: boolean) => void;
  closePopup: () => void;
  openPopup: (showCloseButton?: boolean) => void;
}

const useNonLoginPopup = create<Store>((set) => ({
  opened: false,
  showCloseButton: true,
  setOpened: (flag: boolean) => set(() => ({ opened: flag })),
  closePopup: () =>
    set(() => ({
      opened: false,
    })),
  openPopup: (showCloseButton = true) =>
    set(() => ({ opened: true, showCloseButton })),
}));

export default useNonLoginPopup;
